import { TestimonialsCardProps } from './testimonials.type';
import QuoteWhiteImage from 'assets/img/landing/quotesWhite.svg';
import { Image } from 'react-bootstrap';

function TestimonialsCard({ data }: TestimonialsCardProps) {
  const { displayName, feedBack, image, userName } = data;
  return (
    <div className="px-3 testimonials_carousel_wrapper">
      <div className="bg-gray-1100 rounded-5 testimonials_carousel_wrapper_card">
        <div className="testimonials_carousel_wrapper_card_top h-80 p-4 d-flex flex-column justify-content-between">
          <Image src={QuoteWhiteImage} alt="quotes" width={50} height={50} />
          <div className="text-primary-subtle">{feedBack}</div>
        </div>
        <div className="testimonials_carousel_wrapper_card_bottom h-20 bg-body w-75 py-2 d-flex align-items-center gap-3">
          <Image
            src={image}
            alt="profile"
            width={50}
            height={50}
            className="rounded-circle"
          />
          <div>
            <p className="m-0 fs-lg-8 fs-md-8 fs-9 fw-semibold">
              {displayName}
            </p>
            <p className="m-0 fs-lg-9 fs-md-9 fs-10">{userName}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestimonialsCard;
